import { Breadcrumb } from 'components/Breadcrumb'
import { Button } from 'components/Button'
import { Table } from 'components/Table'
import { Svg } from 'components/Svg'
import { Pagination } from 'components/Pagination'

import { getVenueGroups } from 'api/venues'

import { debounce } from 'utils/debounce'

import addIcon from 'assets/icons/outline/plus.svg'

const VenueGroup = ({ attrs: { item, classes } }) => {
  return {
    view () {
      return m('.flex.flex-shrink-0.hover:bg-gray-300.cursor-pointer', {
        class: classes ? classes.join(' ') : 'bg-white',
        style: {
          height: '40px'
        },
        onclick: () => {
          m.route.set(`/venue-groups/${item.id}`)
        }
      },
      [
        m('.flex.flex-grow.w-0.h-10.px-6.py-3.whitespace-nowrap.truncate.text-sm.font-medium.text-gray-900',
          m(m.route.Link, { href: `/venue-groups/${item.id}` }, item.name)
        )
      ]
      )
    }
  }
}

export const VenueGroups = () => {
  const filters = { page: 1, search: null }

  let venueGroups
  let meta

  getVenueGroups().then(data => {
    venueGroups = data.data
    meta = data.meta
  })

  const debouncedSearch = debounce(val => {
    filters.search = val.length > 2 ? val : null
    getVenueGroups(filters).then(data => {
      venueGroups = data.data
      meta = data.meta
    })
  }, 300)

  return {
    view () {
      return [
        m(Breadcrumb, {
          links: [{
            title: 'Venue Groups'
          }],
          buttons: [
            m(Button, {
              size: 'sm',
              classes: ['my-2', 'mx-auto', 'whitespace-nowrap', 'text-white'],
              type: 'button',
              onclick: () => {
                m.route.set('/venue-groups/create')
              }
            }, [m(Svg, {
              classes: ['w-4', 'mx-auto']
            }, [addIcon]), 'Add Venue Group'])]
        }),
        m('.p-4', { style: { height: 'calc(100% - 3rem)' } }, [
          m('.h-full.shadow.overflow-hidden.border-b.border-gray-200.sm:rounded-lg',
            venueGroups && m(Table, {
              cols: [
                {
                  label: 'Name',
                  search: true,
                  searchOnChange: (val) => {
                    debouncedSearch(val)
                  }
                }
              ],
              filters: true
            },
            [
              m('.overflow-auto',
                venueGroups.map((v, ix) => {
                  return m(VenueGroup, { key: v.id, item: v, classes: [ix % 2 ? 'bg-gray-50' : 'bg-white'] })
                })
              ),
              meta && m(Pagination, {
                meta: meta,
                onpage: (page) => {
                  filters.page = page
                  getVenueGroups(filters).then(data => {
                    venueGroups = data.data
                    meta = data.meta
                  })
                }
              })
            ])
          )
        ])
      ]
    }
  }
}
